<template>
  <div class="page" v-wechat-title="$route.meta.title='授权'">

    <div class='authorize-wrapper'>
      <div class='authorize-main'>
        <div class='authorize-content'>
          <div class='authorize-head'>
            <img src="https://filewc.geeker.com.cn/jpjs_xcx/logo.png" alt="">
            <div class='authorize-title'>金牌解说</div>
          </div>
          <div class='authorize-summary'>为提供优质的服务，需要获取以下信息</div>
          <div class='M-summary'>你的公开信息（昵称、头像等）</div>

          <div class='authorize-btn'> 授权登录中... </div>
          <!--<div class='authorize-btn'>code：-->
            <!--<input type="text" placeholder="code码" v-model='code' style="display:inline-block;width: 80%;font-size: .32rem; color: #444;" />-->
          <!--</div>-->

        </div>
      </div>
    </div>

  </div>

</template>

<script>

import {userinfoLogin, efzSign, efzGetUserInfo} from "@/service/getData";
import {setStore, getStore, removeStore} from '@/config/mUtils'
import {GetQueryString} from '@/utils/author'

import wxConfirm from '@/wechat-messagebox/Confirm'
import D from '@/wc-messagebox'
import Vue from 'vue'
Vue.use(D)

export default {
    data(){
        return{
          userInfo: {}, //用户信息
          sns_info: this.$route.query.sns_info || '', //sns_info :   xc_base (app主动授权)  fz_auth(其他第三方授权)  其他值维持原样
          code: '',
          data: {
            mobile: '',
            nickName: '',
            picUrl: '',
            sex: 1
          },
          rurl: 'https://jpjs.geeker.com.cn/dist/index.html#/authorize-efz'
        }
    },
    created() {
      this.$loading.show('授权登录中');

//      var data = JSON.stringify(this.data);
//      this.getUserInfo(data)
    },
    mounted() {
      this.code = this.$route.query.code || GetQueryString("code") || "";
      this.otherAuth();
    },
    methods: {
        getUserInfo(str){
          this.userInfo = getStore("userInfo");
          if(str==null || str=='' || str == 'undefined'){
            this.$loading.hide();
            this.$alert({
              title: '提示',
              content: '请先到个人中心登录登录'
            });
          }else {
            var user = JSON.parse(str);
            if(user && user.mobile){
              console.log(this.userInfo)
              console.log(user)
              if((this.userInfo && this.userInfo.openid) && (this.userInfo.openid==user.mobile)){
                console.log('不调用授权返回方法');
                return
              }else {
                this.userinfoLoginFun(user)
              }
            }else {
              this.$loading.hide();
              this.$alert({
                title: '提示',
                content: '用户授权失败，请退出重试',
              });
            }
          }

        },

        //重新上传用户信息
        async userinfoLoginFun(user){
          let res = await userinfoLogin({
            openid: user.mobile,
            avatarUrl: user.picUrl,
            nickname: user.nickName,
            city: '',
            gender: user.sex,
            encryptedData: '',
            iv: ''
          });
          if(res.errcode === "00000"){
            var userInfo = {
              openid: user.mobile,
              headimg: user.picUrl,
              headimgurl: user.picUrl,
              istui: 0,
              name: user.nickName,
              nickname: user.nickName,
              sex: user.sex
            };

            setStore("timelogin",{timelogin: new Date().getTime()},1);
            setStore("userInfo", userInfo);
            setStore("userInfo1", userInfo,1);

            this.toNextPage();

          }else {
            this.$loading.hide();
            this.$alert({
              title: '提示',
              content: '用户数据保存失败，请退出重试'
            });
          }
        },

        //跳转到下一页
        toNextPage: function (){
          this.$loading.hide();
          this.$router.replace({  path: `/view-detail?shopid=1609`});
        },

        //调用第三方支付
        otherAuth: function (){
          if (this.code == "" || this.code == null || this.code == "undefined") {
//            this.efzSignFun();
          } else {
            this.efzGetUserInfoFun(this.code);
            console.log(this.code)
          }
        },

        //签名获取sign
        async efzSignFun(){

          var locaurl_base = encodeURIComponent(this.rurl);
          let res = await efzSign({
            clientId: '202003190566',
            redirectUri: this.rurl,
            responseType: 'code',
            scope: 'userInfo',
            display: 'h5'
          });
          if(res.errcode === "00000"){
            var sign = res.data;
            window.location.replace('https://syuias.fuzhou.gov.cn/auth/authorize-efz?clientId=202003190566&redirectUri='+ locaurl_base +'&responseType=code&scope=userInfo&sign='+ sign +'&display=h5')
          }else {
            this.$loading.hide();
            this.$alert({
              title: '提示',
              content: '第三方授权获取签名失败'
            });
          }
        },

        //获取用户信息
        async efzGetUserInfoFun(code){
          let res = await efzGetUserInfo({
            code: code,
            redirectUri: this.rurl
          });
          if(res.errcode === "00000"){

            setStore("timelogin",{timelogin: new Date().getTime()},1);
            setStore("userInfo", res.data);
            setStore("userInfo1", res.data,1);

            this.toNextPage();
          }else {
            this.$loading.hide();
            this.$alert({
              title: '提示',
              content: '第三方授权获取信息失败'
            });
          }
        },



    },
    components: {

    },

}

</script>

<style scoped>

  .page{ background:  #f9f9f9; min-height: 100vh; padding-bottom: 0; }

  .authorize-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
  }

  .authorize-wrapper .authorize-main {
    position: absolute;
    top: 1.50rem;
    left: 5%;
    width: 90%;
    background: #fff;
    color: #333;
    line-height: .48rem;
  }

  .authorize-wrapper .authorize-main .authorize-content {
    padding: .20rem .20rem .60rem;
  }

  .authorize-wrapper .authorize-main .authorize-summary {
    font-size: .28rem;
    line-height: 2;
    padding: 0 .15rem;
  }

  .authorize-wrapper .authorize-main .M-summary {
    padding-bottom: .60rem;
    font-size: .24rem;
    color: #999;
    padding: 0 .15rem;
  }

  .authorize-wrapper .authorize-head {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding: .40rem 0;
  }

  .authorize-wrapper .authorize-head img {
    height: .80rem;
    width: 3.00rem;
    border-radius: .08rem;
    overflow: hidden;
  }

  .authorize-wrapper .authorize-head .authorize-title {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: .36rem;
    line-height: .80rem;
    padding: 0 .15rem;
  }

  .authorize-wrapper .authorize-btn {
    display: block;
    width: 100%;
    height: .80rem;
    line-height: .80rem;
    margin: .9rem auto 0;
    font-size: .32rem;
    letter-spacing: .02rem;
    color: #444;
    background: #ddd;
    text-align: center;
  }




</style>



// WEBPACK FOOTER //
// src/page/home/authorize-efz.vue